import { Injectable } from "@angular/core";
import { BehaviorSubject, timer } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthService } from "./auth.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { Router } from "@angular/router";
import { DialogService } from "./dialog.service";
declare let cordova: any;

@Injectable({
  providedIn: "root",
})
export class FireBaseService {
  deviceDetailSubject = new BehaviorSubject<any>(null);
  deviceDetail = this.deviceDetailSubject.asObservable();

  constructor(
    private authService: AuthService,
    private _angularFireMessaging: AngularFireMessaging,
    private router: Router,
    private dialogService: DialogService
  ) {
    this._angularFireMessaging.messages.subscribe((_messaging) => {
      this._angularFireMessaging.onMessage = this._angularFireMessaging.onMessage.bind(_messaging);
    });
  }

  getToken() {
    this._angularFireMessaging.getToken.subscribe((res) => {
      this.authService.setDeviceToken(res);
      let _deviceDetail = this.deviceDetailSubject.value;
      this.authService.saveDeviceToken({ deviceToken: res, device: _deviceDetail?.os, scope: 'investor' })
    });
  }

  getPermission() {
    if(environment.app && environment.ios){
      timer(500).subscribe(() => {
        cordova.plugins.firebase.messaging.requestPermission().then((res)=>{
          cordova.plugins.firebase.messaging.getToken().then((token)=>{
            this.authService.setDeviceToken(token)
          })
        })
        cordova.plugins.firebase.messaging.onBackgroundMessage((message)=>{
          if (message && message.link) {
            timer(100).subscribe(() => {
              this.dialogService.closeAll();
              this.router.navigate([message.link]);
            });
          }
        })
      })  
    } else if(environment.app && environment.android){
      if(typeof window !== 'undefined'){
        const firebase = (window as any).FirebasePlugin
        firebase.grantPermission((success)=>{
          if(success){
            firebase.getToken((token)=>{
              this.authService.setDeviceToken(token)
              this.getAndroidMessages()
            },(err)=>{
              console.log('err: ', err);
            })
          }
        })
        firebase.hasPermission((success)=>{
          if(success){
            firebase.getToken((token)=>{
              this.authService.setDeviceToken(token)
              this.getAndroidMessages()
            },(err)=>{
              console.log('err: ', err);
            })
          }
        })
      }
    } else {
      this._angularFireMessaging.requestPermission.subscribe((res) => {
        this.getToken();
      });
    }
  }

  getAndroidMessages = () => {
    if(typeof window !== 'undefined'){
      (window as any).FirebasePlugin.onMessageReceived(
        (message: any) => {
          if (message && message.tap === 'background') {
            timer(100).subscribe(() => {
              this.dialogService.closeAll();
              this.router.navigate([message.link]);
            });
          }
        });
    }
  }

  calculateDeviceDetail() {
    let deviceDetais: any = {};
    if (typeof screen !== 'undefined' && screen.width) {
      let width = screen.width ? screen.width : "";
      let height = screen.height ? screen.height : "";
      deviceDetais.screenSize = width + " x " + height;
    }
    deviceDetais.longitude = "-";
    deviceDetais.longitude = "-";
    if(typeof navigator !== 'undefined'){
      if (navigator.geolocation && environment.android) {
        navigator.geolocation.getCurrentPosition(
          (obj) => {
            deviceDetais.latitude = obj.coords.latitude;
            deviceDetais.longitude = obj.coords.longitude;
          },
          (err) => { }
        );
      }
      // browser
      let nVer = navigator.appVersion;
      let nAgt = navigator.userAgent;
      let browser = navigator.appName;
      let version = "" + parseFloat(navigator.appVersion);
      let majorVersion = parseInt(navigator.appVersion, 10);

      let nameOffset: any, verOffset: any, ix: any;

      // Opera
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
      }
      // Edge
      else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
      }
      // MSIE
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
      }
      // Chrome
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
      }
      // Safari
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Firefox
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
      }
      // MSIE 11+
      else if (nAgt.indexOf("Trident/") != -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
      }
      // Other browsers
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
          browser = navigator.appName;
        }
      }
      // trim the version string
      if ((ix = version.indexOf(";")) != -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(" ")) != -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(")")) != -1) version = version.substring(0, ix);

      majorVersion = parseInt("" + version, 10);

      if (isNaN(majorVersion)) {
        version = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }
      deviceDetais.version = version;
      deviceDetais.majorVersion = majorVersion;
      deviceDetais.browser = browser;

      // mobile version
      deviceDetais.isMobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(
        nVer
      );
      // cookie
      let cookieEnabled = navigator.cookieEnabled ? true : false;
      if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled =
          document.cookie.indexOf("testcookie") != -1 ? true : false;
      }
      deviceDetais.cookieEnabled = cookieEnabled;
      // system
      let os = "-";
      let clientStrings = [
        { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
        { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
        { s: "Windows Vista", r: /Windows NT 6.0/ },
        { s: "Windows Server 2003", r: /Windows NT 5.2/ },
        { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
        { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
        { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
        { s: "Windows 98", r: /(Windows 98|Win98)/ },
        { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
        {
          s: "Windows NT 4.0",
          r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/,
        },
        { s: "Windows CE", r: /Windows CE/ },
        { s: "Windows 3.11", r: /Win16/ },
        { s: "Android", r: /Android/ },
        { s: "Open BSD", r: /OpenBSD/ },
        { s: "Sun OS", r: /SunOS/ },
        { s: "Linux", r: /(Linux|X11)/ },
        { s: "iOS", r: /(iPhone|iPad|iPod)/ },
        { s: "Mac OS X", r: /Mac OS X/ },
        { s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: "QNX", r: /QNX/ },
        { s: "UNIX", r: /UNIX/ },
        { s: "BeOS", r: /BeOS/ },
        { s: "OS/2", r: /OS\/2/ },
        {
          s: "Search Bot",
          r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
        },
      ];
      for (let id in clientStrings) {
        let cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
          os = cs.s;
          break;
        }
      }

      let osVersion: any = "-";

      if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
      }

      switch (os) {
        case "Mac OS X":
          osVersion = /Mac OS X ([\.\_\d]+)/.exec(nAgt)[1];
          break;

        case "Android":
          osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
          break;

        case "iOS":
          osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
          osVersion =
            osVersion[1] + "." + osVersion[2] + "." + (osVersion[3] | 0);
          break;
      }
      deviceDetais.os = os;
      deviceDetais.osVersion = osVersion;
      deviceDetais.platform = "Localhost";
      if (environment.app) {
        deviceDetais.platform = "Mobile App";
      } else if (environment.production) {
        deviceDetais.platform = "Web App";
      } else if (environment.stage) {
        deviceDetais.platform = "Stage Web App";
      }
      this.deviceDetailSubject.next(deviceDetais);
    }
  }
}